import { render, staticRenderFns } from "./Violations.vue?vue&type=template&id=6abb622b&scoped=true"
import script from "./Violations.vue?vue&type=script&lang=js"
export * from "./Violations.vue?vue&type=script&lang=js"
import style0 from "./Violations.vue?vue&type=style&index=0&id=6abb622b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abb622b",
  null
  
)

export default component.exports